import { RouteObject } from 'react-router';

const lazyDispatchRoute = () =>
  import('./DispatchRoute/DispatchRoute').then((m) => ({
    Component: m.DispatchRoute,
  }));

export const dispatchRoutes: RouteObject[] = [
  {
    index: true,
    lazy: lazyDispatchRoute,
  },
  {
    path: ':selectedDate',
    lazy: lazyDispatchRoute,
  },
  {
    path: ':selectedDate/:rbrJobId',
    lazy: () =>
      import('./RunBambiRunRoute/RunBambiRunRoute').then((m) => ({
        Component: m.RunBambiRunRoute,
      })),
  },
];
